import {PostAcceptWellBornProgramParams} from 'domain/usecases/private/well-born/post-accept-well-born-program';
import {makePostAcceptWellBornProgram} from 'main/factories/usecases/private/well-born/post-accept-program';

export async function postAcceptWellBornProgram(params: PostAcceptWellBornProgramParams) {
	const acceptWellBornProgram = makePostAcceptWellBornProgram();
	return acceptWellBornProgram.accept(params);
}
